import React, { useState } from 'react'
import feature from '../../assets/fake-data/landingpage-four/feature'
import { Link } from 'react-router-dom'

const Feature = () => {
    const [dataBlock] = useState({
        title:"Our Featured Service That We Provide",
        subTitle: "Due to its widespread use as filler text for layouts, non-readability is of great importance."
    })
  return (
    <>
         <section className="py-20">
        <div className="container">
            <div className="grid grid-cols-1">
                <div className="text-center">
                    <h2 className="font-bold text-[32px] md:text-[40px] capitalize mb-2 relative z-10"><span className="bg-[#dff1f0] h-[70px] w-[70px] inline-block absolute rounded-full -z-10 -top-[15px]"></span>{dataBlock.title}</h2>
                    <p className="text-muted mx-auto text-lg max-w-[600px] mt-6">{dataBlock.subTitle}</p>
                </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px] mt-16">
            {feature.map((x) => {
                return <div key={x.id} className={` ${x.id == 2 ? "rounded-[5px] border border-[#eaeaea]" : "" } text-center py-12 px-4`}>
                    <div className="shadow-[10px_-10px_0_0_rgba(10,161,149,15%)] w-[56px] h-[56px] leading-[56px] text-center inline-block bg-custom rounded-md"><p className="text-white font-bold text-[28px]">{x.id}.</p></div>
                    <h4 className="mt-6 font-bold text-xl">{x.name}</h4>
                    <p className="text-muted mt-4">{x.description}</p>
                    <div className="featres_btn mt-6">
                        <Link to="#" className="text-muted">{x.linkName} <i className="mdi mdi-arrow-right text-custom text-xl relative top-[3px]"></i></Link>
                    </div>
                </div>
            })}
            </div>
        </div>
    </section>
    </>
  )
}

export default Feature